// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cqnFCVd0BUo2oG {
  min-width: 120px;
  margin: var(--ds-space-050, 4px);
}
.ituUIiYm75N7rG {
  box-sizing: border-box;
}
.ituUIiYm75N7rG a {
  outline: none;
}
.opgOpq1jI2kkdk {
  outline-offset: var(--ds-space-025, 2px);
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .opgOpq1jI2kkdk {
  outline-color: -webkit-focus-ring-color;
}
.opgOpq1jI2kkdk .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardSwitcherTile": `cqnFCVd0BUo2oG`,
	"boardSwitcherListTile": `ituUIiYm75N7rG`,
	"activeBoardTile": `opgOpq1jI2kkdk`
};
export default ___CSS_LOADER_EXPORT___;
